import { api } from "./api";
import { PriceChangeRequestStatus } from "../types/priceChangeRequest.type";

export const priceChangeRequestApi = {
  getRequests: async (params?: {
    page?: number;
    limit?: number;
    status?: PriceChangeRequestStatus | "all";
    search?: string;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
  }) => {
    const response = await api.get("/price-change-request", { params });
    return response.data;
  },

  getPendingCount: async () => {
    const response = await api.get("/price-change-request/pending-count");
    return response.data as { count: number };
  },

  getById: async (id: string) => {
    const response = await api.get(`/price-change-request/${id}`);
    return response.data;
  },

  approve: async (id: string, data?: { notes?: string }) => {
    const response = await api.put(`/price-change-request/${id}/approve`, data);
    return response.data;
  },

  reject: async (id: string, data?: { reason?: string }) => {
    const response = await api.put(`/price-change-request/${id}/reject`, data);
    return response.data;
  },

  bulkApprove: async (data: { ids: string[]; notes?: string }) => {
    const response = await api.post("/price-change-request/bulk-approve", data);
    return response.data as BulkResult & { approved: number };
  },

  bulkReject: async (data: { ids: string[]; reason?: string }) => {
    const response = await api.post("/price-change-request/bulk-reject", data);
    return response.data as BulkResult & { rejected: number };
  },

  // Запускает пересчёт ФОНОМ и сразу возвращает jobId — прогресс опрашивается
  // через getRecomputeStatus. Синхронный вызов не укладывался в таймаут.
  recompute: async (data?: { categoryId?: string }) => {
    const response = await api.post("/price-change-request/recompute", data);
    return response.data as { message: string; jobId: string; total: number };
  },

  getRecomputeStatus: async (jobId?: string) => {
    const response = await api.get(
      `/price-change-request/recompute/status/${jobId || ""}`
    );
    return response.data as RecomputeJob;
  },
};

/** Результат массовой операции: часть могла не пройти — причины в failures. */
export interface BulkResult {
  message: string;
  failed: number;
  failures?: Array<{ id: string; error: string }>;
}

export interface RecomputeJob {
  id: string;
  status: "running" | "done" | "failed";
  total: number;
  processed: number;
  created: number;
  skipped: number;
  startedAt: string;
  finishedAt?: string;
  error?: string;
  startedByName?: string;
  categoryId?: string | null;
}
